/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCreateEditReviewRequest } from '../models/TCreateEditReviewRequest';
import type { TCreateEditReviewResponse } from '../models/TCreateEditReviewResponse';
import type { TEditId } from '../models/TEditId';
import type { TGetEditReviewResponse } from '../models/TGetEditReviewResponse';
import type { TIdentifyPerformerRequest } from '../models/TIdentifyPerformerRequest';
import type { TIdentifyPerformerResponse } from '../models/TIdentifyPerformerResponse';
import type { TMarkPerformerInvalidRequest } from '../models/TMarkPerformerInvalidRequest';
import type { TMarkPerformerInvalidResponse } from '../models/TMarkPerformerInvalidResponse';
import type { TMergePerformersRequest } from '../models/TMergePerformersRequest';
import type { TMergePerformersResponse } from '../models/TMergePerformersResponse';
import type { TOutgradePerformerRequest } from '../models/TOutgradePerformerRequest';
import type { TOutgradePerformerResponse } from '../models/TOutgradePerformerResponse';
import type { TReclassifyPerformerRequest } from '../models/TReclassifyPerformerRequest';
import type { TReclassifyPerformerResponse } from '../models/TReclassifyPerformerResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EditReviewService {
    /**
     * Get EditReview
     * @param editId
     * @param relations
     * @returns TGetEditReviewResponse TGetEditReviewResponse
     * @throws ApiError
     */
    public static getEditReviewByEditId(
        editId: TEditId,
        relations?: string,
    ): CancelablePromise<TGetEditReviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/edit-reviews/{editId}',
            path: {
                'editId': editId,
            },
            query: {
                'relations': relations,
            },
        });
    }
    /**
     * Create EditReview
     * @param requestBody
     * @returns TCreateEditReviewResponse TCreateEditReviewResponse
     * @throws ApiError
     */
    public static createEditReview(
        requestBody: TCreateEditReviewRequest,
    ): CancelablePromise<TCreateEditReviewResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/edit-reviews',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reclassify performer (upgrade/downgrade)
     * @param editId
     * @param requestBody
     * @returns TReclassifyPerformerResponse TReclassifyPerformerResponse
     * @throws ApiError
     */
    public static reclassifyPerformer(
        editId: TEditId,
        requestBody: TReclassifyPerformerRequest,
    ): CancelablePromise<TReclassifyPerformerResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/edit-reviews/{editId}/reclassify',
            path: {
                'editId': editId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Mark performer as invalid detection (false positive)
     * @param editId
     * @param requestBody
     * @returns TMarkPerformerInvalidResponse TMarkPerformerInvalidResponse
     * @throws ApiError
     */
    public static markPerformerInvalid(
        editId: TEditId,
        requestBody: TMarkPerformerInvalidRequest,
    ): CancelablePromise<TMarkPerformerInvalidResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/edit-reviews/{editId}/mark-invalid',
            path: {
                'editId': editId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Outgrade performer (contracted performer not in edit)
     * @param editId
     * @param requestBody
     * @returns TOutgradePerformerResponse TOutgradePerformerResponse
     * @throws ApiError
     */
    public static outgradePerformer(
        editId: TEditId,
        requestBody: TOutgradePerformerRequest,
    ): CancelablePromise<TOutgradePerformerResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/edit-reviews/{editId}/outgrade',
            path: {
                'editId': editId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Merge multiple performers into one (Phase 3)
     * @param editId
     * @param requestBody
     * @returns TMergePerformersResponse TMergePerformersResponse
     * @throws ApiError
     */
    public static mergePerformers(
        editId: TEditId,
        requestBody: TMergePerformersRequest,
    ): CancelablePromise<TMergePerformersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/edit-reviews/{editId}/merge-performers',
            path: {
                'editId': editId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Identify unknown performer as contracted performer (Phase 3)
     * @param editId
     * @param requestBody
     * @returns TIdentifyPerformerResponse TIdentifyPerformerResponse
     * @throws ApiError
     */
    public static identifyPerformer(
        editId: TEditId,
        requestBody: TIdentifyPerformerRequest,
    ): CancelablePromise<TIdentifyPerformerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/edit-reviews/{editId}/identify-performer',
            path: {
                'editId': editId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
